<template>
	<bsh-modal 
		titulo="Nova Tag"
		:name="name">
		<template v-slot:default>
	        <pedido-tags-form
				:dados="dados"
				:name="name"
				:errors="errors">
			</pedido-tags-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import PedidoTag from "./../../models/PedidoTag.js";
	export default {
		data(){
			return {
				dados: new PedidoTag(),
				name: 'create_pedido_tag',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
				this.dados.pedido_id = this.$route.params.id;
	            axios.post(this.$url+'/api/adm/pedido-tags/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new PedidoTag()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>